// extracted by mini-css-extract-plugin
export default {"container":"default_container__WD+S7","content":"default_content__qhEz+"};